import { render, staticRenderFns } from "./OsdiDialog.vue?vue&type=template&id=b365ca2c&scoped=true&"
import script from "./OsdiDialog.vue?vue&type=script&lang=ts&"
export * from "./OsdiDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OsdiDialog.vue?vue&type=style&index=0&id=b365ca2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b365ca2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VContainer,VDialog,VSheet,VSpacer,VToolbar})
